import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { BaseResizableComponent } from '@src/app/modules/base';

import { LoyaltyProgramCollection } from '../../types';

@Component({
  selector: 'lp-collection-view',
  templateUrl: './lp-collection-view.component.html',
  styleUrls: ['./lp-collection-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LpCollectionViewComponent extends BaseResizableComponent {
  @Input() data?: LoyaltyProgramCollection | null;
  @Input() ref?: string;

  @Input() loading = false;

  @Input() allowEditing: boolean | null = false;
  @Input() allowDeleting: boolean | null = false;

  @Output() edit = new EventEmitter<void>();
  @Output() delete = new EventEmitter<string>();
}
